import Vue from 'vue'
import util from "@/common/libs/util";

// 自定义指令编写文档： https://cn.vuejs.org/v2/guide/custom-directive.html
// 轮播点击统计
Vue.directive('carousel-count', {
    bind: function (el, binding) {
        //获取图片id
        var value = binding.value;
        if (value) {
            var params = {}
            var interface_key = el.getAttribute('interface-key') || 'id'
            var interface_name = el.getAttribute('interface')

            params[interface_key] = value

            // 避免重复绑定
            if (el.disabled) {
                return
            }
            el.disabled = true
            el.addEventListener('click', () => {
                var kind = interface_name || 'count_click'
                util.get('kzp_common', kind, params).then((res) => {
                    console.log('点击量', res)
                })
            })
        }
    }
});

// 天眼查引流点击统计
Vue.directive('tyc-count', {
    // 指令所在组件的 VNode 及其子 VNode 全部更新后调用
    componentUpdated: function (el, binding, vnode, oldVnode) {
        var company_name = el.getAttribute("name");
        if (company_name) {
            var href = "https://www.tianyancha.com/search/" + company_name;
            Vue.nextTick(function () {
                // DOM 更新了
                el.setAttribute("href", href)
            })
        }
    },
    // 只调用一次，指令第一次绑定到元素时调用。在这里可以进行一次性的初始化设置
    bind: function (el, binding) {
        // el：指令绑定的元素，如果是组件，那么不能直接操作它的属性
        var value = el.getAttribute('key-value');
        if (!value) {
            return;
        }

        var params = {};
        // 获取传参值
        var key = el.getAttribute('key-name') || 'state';
        params[key] = value;

        var countHttp = function () {
            util.get('kzp_common', "tyc_click", params).then((res) => {
                console.log('点击量', res)
            })
        }

        el.addEventListener('click', function () {
            var href = this.getAttribute("href");
            if (!href) {
                return
            }

            if (this.nodeName !== "A") {
                // 非a标签
                var a = document.createElement("a");
                a.setAttribute("target", "_blank");
                a.setAttribute("href", href);
                a.click();
            }
            
            // 存在链接，进行接口请求
            countHttp();
        })
    }
});


// WEBPACK FOOTER //
// ./src/global/directive.js